var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.939 0C16.28 0 17.57 0.53 18.519 1.481C19.469 2.43 20 3.71 20 5.05V12.95C20 15.74 17.73 18 14.939 18H5.06C2.269 18 0 15.74 0 12.95V5.05C0 2.26 2.259 0 5.06 0H14.939ZM16.5299 6.53984L16.6099 6.45984C16.8489 6.16984 16.8489 5.74984 16.5989 5.45984C16.4599 5.31084 16.2689 5.21984 16.0699 5.19984C15.8599 5.18884 15.6599 5.25984 15.5089 5.39984L10.9999 8.99984C10.4199 9.48084 9.58893 9.48084 8.99993 8.99984L4.49993 5.39984C4.18893 5.16984 3.75893 5.19984 3.49993 5.46984C3.22993 5.73984 3.19993 6.16984 3.42893 6.46984L3.55993 6.59984L8.10993 10.1498C8.66993 10.5898 9.34893 10.8298 10.0599 10.8298C10.7689 10.8298 11.4599 10.5898 12.0189 10.1498L16.5299 6.53984Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f10fe16318fe05e104c310a89e6f53e2.svg";
export { ForwardRef as ReactComponent };